import * as React from "react";
import { FormFeedback, FormGroup, Input, Label } from "reactstrap";
import PortalPanel from "../../shared/PortalPanel";
import { emailRegExp } from "utils/Regex";

const emailRegex = new RegExp(emailRegExp);

const Login: React.FC<{
  email: string;
  imagePath?: string;
  onEmailChange?: (email: string) => void;
  onGoNext: () => void;
  onGoBack?: () => void;
}> = ({ email, imagePath, onGoNext, onEmailChange, onGoBack }) => {
  const [isEmailTouched, setIsEmailTouched] = React.useState(false);

  const isEmailInvalid = !emailRegex.test(email);

  return (
    <PortalPanel
      image={imagePath}
      title="Sign in to your Marble account"
      onGoBack={onGoBack}
      primaryButton={{
        text: "Continue",
        action: onGoNext,
        isDisabled: isEmailInvalid,
      }}
    >
      <FormGroup floating>
        <Input
          name="emailAddress"
          defaultValue={email}
          onChange={(e) => {
            setIsEmailTouched(true);
            if (onEmailChange) {
              onEmailChange(e.target.value);
            }
          }}
          placeholder="Email Address"
          invalid={isEmailTouched && isEmailInvalid}
        />
        <Label>Email Address</Label>
        <FormFeedback>Enter a valid email</FormFeedback>
      </FormGroup>
    </PortalPanel>
  );
};

export default Login;
